<template>
  <div>
    <div class="detail-header">
      <div class="header-main content">
        <div>
          <img src="../../static/img/index/headtitle.png">
          <div class="header-search">
            <div class="input-text">
              <input type="text" class="form-control dropdown-toggle" data-toggle="dropdown" placeholder="请输入您要搜索的内容"
                     aria-expanded="false" v-model="key" @keyup.enter="openSearch">
              <span class="input-group-btn">
              <button class="btn btn-warning" type="submit" @click="openSearch">搜 索</button>
            </span>
            </div>
            <!-- 修复函数名拼写错误 openNewPag → openNewPage -->
            <div class="hotsearch" @click="openNewPage('https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000')">
            </div>
          </div>
        </div>
        <div class="sub-title">路标式政务服务事项解读体系</div>
        <img class="gzjz" src="../../static/img/index/gzjz.png">
      </div>
    </div>
    <div class="main g-main">
      <div class="content">
        <div class="header-title">
          <div class="title">
            <span>办事服务</span>
          </div>
          <div class="btngroup">
            <div style="margin-top: 5px">
              <input type="checkbox" name="level" style="vertical-align: -2px;">
              <label for="level" class="checklabeltext">仅显示本级</label>
            </div>
            <div class="btn-group">
              <el-select v-model="filterWord1" @change="wordSearch(1)">
                <el-option value="">全部部门</el-option>
                <!-- 新增:key 消除编译警告 -->
                <el-option v-for="(item, idx) in filterWordList1" :key="idx" :value="item">{{item}}</el-option>
              </el-select>
            </div>
            <div class="btn-group">
              <el-select v-model="filterWord2" @change="wordSearch(2)">
                <el-option value="">全部对象</el-option>
                <el-option v-for="(item, idx) in filterWordList2" :key="idx" :value="item">{{item}}</el-option>
              </el-select>
            </div>
            <div class="btn-group">
              <el-select v-model="filterWord3" @change="wordSearch(3)">
                <el-option value="">全部类型</el-option>
                <el-option v-for="(item, idx) in filterWordList3" :key="idx" :value="item">{{item}}</el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- 分页列表改用事项名称作为唯一key，避免翻页渲染错乱 -->
        <div class="table-list" v-for="item in resList.slice(page * pageLimit, page * pageLimit + pageLimit)"
             :key="item.shixiangmingcheng">
          <div class="toptitle">
            <div class="text">
              <!-- 修复点击不传item导致openDetail报错 -->
              <a href="javascript:" @click="openDetail(item)">
                <span class="emphasis" v-html="item.shixiangmingcheng1"></span>
              </a>
            </div>
            <div class="rightbtn-group">
              <div :class="[detailList.includes(item.shixiangmingcheng) ? 'rightbtn rightbtn-active' : 'rightbtn rightbtn-disable']"
                   @click="openDetail(item)">
                <span>"路标式"解读</span>
              </div>
              <div :class="[item.yijianshi && item.yijianshi.length > 1 ? 'rightbtn' : 'rightbtn rightbtn-disable']"
                   @click="openNewPage(item.yijianshi)">
                <span>一件事</span>
              </div>
              <!--              <div :class="[item.zhinengyindao.length > 1 ? 'rightbtn' : 'rightbtn']" @click="openIntelligent" >-->
              <!--                <span>智能引导</span>-->
              <!--              </div>-->
              <div :class="[item.banshizhinan && item.banshizhinan.length > 1 ? 'rightbtn' : 'rightbtn rightbtn-disable']"
                   @click="openNewPage(item.banshizhinan)">
                <span>办事指南</span>
              </div>
              <div :class="[item.shoujibanli && item.shoujibanli.length > 1 ? 'rightbtn' : 'rightbtn rightbtn-disable']"
                   @click="openNewPage(item.shoujibanli)">
                <span>手机办理</span>
              </div>
              <div :class="[item.zaixianbanli && item.zaixianbanli.length > 1 ? 'rightbtn' : 'rightbtn rightbtn-disable']"
                   @click="openNewPage(item.zaixianbanli)">
                <span>在线办理</span>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <tbody>
              <tr>
                <td class="col-xs-2 active">相关部门:</td>
                <td class="col-xs-4">{{ item.xiangguanbumen }}</td>
                <td class="col-xs-2 active">责任处（科）室:</td>
                <td class="col-xs-4">{{ item.zerenchukeshi }}</td>
              </tr>
              <tr>
                <td class="col-xs-2 active">法定办结时限:</td>
                <td class="col-xs-4">{{ item.fadingbanjieshixian }}</td>
                <td class="col-xs-2 active">承诺时限:</td>
                <td class="col-xs-4">{{ item.chengnuoshixian }}</td>
              </tr>
              <tr>
                <td class="col-xs-2 active">咨询电话:</td>
                <td class="col-xs-4">{{ item.zixundianhua }}</td>
                <td class="col-xs-2 active">办理形式：</td>
                <td class="col-xs-4">{{ item.banlixingshi }}</td>
              </tr>
              <tr>
                <td class="active">咨询地址:</td>
                <td colspan="3">{{ item.zixundizhi }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="page">
          <ul class="pagination" v-if="totalPage < 8">
            <li :class="[page <= 0 ? 'previous disabled' : 'previous']">
              <a @click="prePageClick" aria-label="Previous"></a>
            </li>
            <!-- 分页页码v-for补充key消除警告 -->
            <li :class="[n - 1 == page ? 'active' : '']" v-for="n in totalPage" :key="n">
              <a @click="setPage(n)">{{ n }}</a>
            </li>
            <li :class="[page + 1 >= totalPage ? 'next disabled' : 'next']">
              <a @click="nextPageClick" aria-label="Next"></a>
            </li>
          </ul>
          <ul class="pagination" v-if="totalPage >= 8">
            <li :class="[page <= 0 ? 'previous disabled' : 'previous']">
              <a @click="prePageClick" aria-label="Previous"></a>
            </li>
            <li :class="[0 == page ? 'active' : '']"><a @click="setPage(1)">1</a></li>
            <li :class="[1 == page ? 'active' : '']"><a @click="setPage(2)">2</a></li>
            <li :class="[2 == page ? 'active' : '']"><a @click="setPage(3)">3</a></li>
            <li :class="[3 == page ? 'active' : '']"><a @click="setPage(4)">4</a></li>
            <li><a href="#">...</a></li>
            <li :class="[7 == page ? 'active' : '']"><a @click="setPage(8)">8</a></li>
            <li :class="[page + 1 >= totalPage ? 'next disabled' : 'next']">
              <a @click="nextPageClick" aria-label="Next"></a>
            </li>
          </ul>
          <ul class="page-length list-inline">
            <li><span>跳至</span></li>
            <li>
              <input type="number" class="form-control" v-model="inputPage" @blur="inputBlur">
            </li>
            <li><span>页</span></li>
          </ul>
        </div>
        <div class="bottom-tooltip">
          <span>没有找到您想要的结果？</span><br/>
          <!-- 修复文字笔误：又 → 有 -->
          <span>您还可以通过<span style="color:#208bef">智能客服</span>或拨打电话12345咨询，希望对您有帮助。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jdsxJson from "../../static/js/search_jdsx.json"
import sxJson from "../../static/js/search_sx.json"
export default {
  name: "Search",
  data() {
    return {
      key: "",
      jdsxList: jdsxJson.Sheet1,
      sxList: sxJson.Sheet1,
      totalList: [],
      resList: [],
      oriResList: [],
      currentPageList: [],
      page: 0,
      pageLimit: 6,
      totalPage: 0,
      inputPage: 0,
      dis: true,
      filterWordList1: [],
      filterWordList2: [],
      filterWordList3: [],
      filterWord1: "",
      filterWord2: "",
      filterWord3: "",
      detailList: [
        "随父（或母）入户登记",
        "随第三方入户登记",
        "随军出生登记入户",
        "南粤扶残助学工程",
        "就业困难人员认定",
        "申领居住证",
        "签注居住证",
        "投靠配偶",
        "档案查询",
        "企业职工领取养老保险待遇资格认证",
        "户口注销证明",
        "合伙企业设立登记",
        "内资有限责任公司设立登记",
        "内资有限责任公司变更登记",
        "外商投资有限责任公司备案",
        "企业注册登记档案查询",
        "食品经营许可证核发（实施申请人承诺制的小餐饮)",
        "公共场所卫生许可（新证，含改、扩建)",
        "设置大型户外广告审批",
        "公众聚集场所投入使用、营业前消防安全检查（告知承诺件）",
        "药品经营许可证核准（零售)",
        "医疗机构执业许可（执业登记)",
        "娱乐场所从事娱乐场所经营活动审批",
        "非学历教育机构设立",
        "公众聚集场所投入使用、营业前消防安全检查",
        "印章刻制业许可证核发",
        "排污许可证核发（新申请/重新申请）",
        "建设项目环境影响报告表审批",
        "动物诊疗许可证核发",
        "危险化学品经营许可证（无储存设施）",
        "就业登记",
        "天河区服务外包业绩奖励",
        "增值税一般纳税人登记",
        "合伙企业注销登记",
        "内资有限责任公司注销登记 （一般注销）",
        "社会团体注销登记",
        "个人独资企业设立登记",
        "个体工商户注销登记"
      ],
      detailListUrl: [
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailBorn1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailBorn2",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailBorn3",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailStudy1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailWork1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailHouse1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise18",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailMarriage1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailCredit1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailRetirement1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailDeath1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise2",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise3",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise4",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise6",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise10",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise12",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise13",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate3",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate4",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate5",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise11",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate6",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate7",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise14",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise17",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate8",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailRecruit1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise8",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailPay1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailLogout1",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise5",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise9",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise31",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailLogout5",
        "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate14"
      ],
    }
  },

  mounted() {
    this.key = this.$route.query.key
    console.log("搜索关键字" + this.key)
    this.totalList = this.jdsxList.concat(this.sxList)
    this.openSearch()
  },
  methods: {
    wordSearch(val) {
      this.page = 0
      if (val == 1) {
        var key = this.filterWord1
        console.log("筛选:" + key)
        var res = this.oriResList.filter(item => item.quanbubumen == key)
        this.changeColor(res)
      }
      if (val == 2) {
        var key = this.filterWord2
        var res = this.oriResList.filter(item => item.quanbuduixiang == key)
        this.changeColor(res)
      }
      if (val == 3) {
        var key = this.filterWord3
        var res = this.oriResList.filter(item => item.quanbuleixing == key)
        this.changeColor(res)
      }
      this.totalPage = this.pageCount()
      console.log("总页数" + this.totalPage)
    },
    openDetail(item) {
      if (this.detailList.includes(item.shixiangmingcheng)) {
        window.open(this.detailListUrl[this.detailList.indexOf(item.shixiangmingcheng)], '_blank')
      } else {
        console.log("没有路标式解读" + item.shixiangmingcheng)
      }
    },
    openIntelligent() {
      let routeData = this.$router.resolve({
        name: 'intelligent',
      });
      window.open(routeData.href, '_blank')
    },
    openSearch() {
      var key = this.key
      console.log(key)
      if (key == null || key == "") {
        return
      }
      this.page = 0
      var res = this.totalList.filter((item) => {
        if (item.shixiangmingcheng.includes(key) || item.shixiangmingcheng.indexOf(key) > 0 || item.sousuokeyongyu.includes(key)) {
          console.log(item.shixiangmingcheng)
          return true
        }
        return false
      })
      console.log("搜索结果长度" + res.length)
      this.changeColor(res)
      this.oriResList = res

      // 全部部门
      var filterWordList1 = res.map((item) => {
        return item.quanbubumen;
      })
      const map1 = new Map()
      this.filterWordList1 = filterWordList1.filter(item => !map1.has(item) && map1.set(item, 1))
      // 全部对象
      var filterWordList2 = res.map((item) => {
        return item.quanbuduixiang;
      })
      const map2 = new Map()
      this.filterWordList2 = filterWordList2.filter(item => !map2.has(item) && map2.set(item, 1))
      // 全部类型
      var filterWordList3 = res.map((item) => {
        return item.quanbuleixing;
      })
      const map3 = new Map()
      this.filterWordList3 = filterWordList3.filter(item => !map3.has(item) && map3.set(item, 1))
      console.log("全部部门" + this.filterWordList1)
      this.totalPage = this.pageCount()
      console.log("总页数" + this.totalPage)
    },
    changeColor(result) {
      result.map((item, index) => {
        if (this.key) {
          let replaceReg = new RegExp(this.key, "ig");
          let replaceString = `<span style="color: #ed4014">${this.key}</span>`;
          result[index].shixiangmingcheng1 = item.shixiangmingcheng.replace(replaceReg, replaceString);
        }
      });
      this.resList = result;
    },
    // 修复空url调用includes报错
    openNewPage(url) {
      if (!url) return
      if (url.includes("http")) {
        window.open(url)
      }
    },
    pageCount() {
      var num = (this.resList.length + this.pageLimit - 1) / this.pageLimit
      return parseInt(num)
    },
    setPage(num) {
      if (this.page == num - 1) {
        return
      }
      this.page = num - 1
    },
    prePageClick() {
      if (this.page <= 0) {
        return
      }
      this.page -= 1
    },
    nextPageClick() {
      if (this.page + 1 >= this.totalPage) {
        return
      }
      this.page += 1
    },
    inputBlur() {
      if (this.inputPage <= 0 || this.inputPage > this.totalPage) {
        return
      }
      this.page = this.inputPage - 1
    }
  }
}
</script>

<style>
@import "../../static/css/bootstrap.min.css";
@import "../../static/css/global.css";
@import "../../static/css/common.css";
@import '../../static/js/vendor/swiper/swiper-bundle.min.css';
@import '../../static/css/search.css';
</style>


// WEBPACK FOOTER //
// Search.vue?55698c44